import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectReport = createSelector(
  [(store: RootState) => store.documentsList.report],
  (data) =>
    [...(data || [])].sort((a, b) => {
      if (a.users.length > b.users.length) {
        return -1;
      }
      return 1;
    })
);
